import { createPaginatedKey } from "api/keys";

export const salesAccountKeys = {
  details: (id: string) => ["salesAccount", id],
  list: createPaginatedKey("salesAccounts"),
};
